"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinNowButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const wide_button_1 = require("./wide_button");
function JoinNowButton(_a) {
    var { onClick, disabled } = _a, props = __rest(_a, ["onClick", "disabled"]);
    return ((0, jsx_runtime_1.jsx)(wide_button_1.WideButton, Object.assign({ testid: "join-now-btn", onClick: onClick, icon: 'CTAIcon', "data-streem-analytics": "call-lobby-join-button", disabled: disabled }, props, { children: "Join Now" })));
}
exports.JoinNowButton = JoinNowButton;
//# sourceMappingURL=join_now_button.js.map